import Modal from "react-bootstrap/Modal";
import { useModal } from "../Contexts/ModalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

function GlobalModal() {
  const { isOpen, closeModal, modalContent, modalTitle, modalSize } = useModal();

  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      size={modalSize !== "fullscreen" && modalSize}
      fullscreen={modalSize === "fullscreen" ? true : false}
    >
      <Modal.Header closeButton={modalSize === "fullscreen" ? false : true}>
        <Modal.Title>{modalTitle}</Modal.Title>
        {modalSize === "fullscreen" && (
          <button type="button" className="btn btn-sm btn-outline-light ms-auto" onClick={() => closeModal()}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
      </Modal.Header>
      <Modal.Body>{modalContent}</Modal.Body>
    </Modal>
  );
}

export default GlobalModal;
